import { SCRIPT_URI_ADDON, TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import {
  downloadFileFromURL,
  getFileNameFromPath
} from '../../../util/util-common';
import {
  deleteRequest,
  getRequest,
  postRequest,
  patchRequest
} from '../../Common/network-call';

export const FETCH_SOCIAL_FEED = 'FETCH_SOCIAL_FEED';
export const FETCH_SOCIAL_FEED_COMMENT = 'FETCH_SOCIAL_FEED_COMMENT';
export const SET_SOCIAL_FEED_COMMENT = 'SET_SOCIAL_FEED_COMMENT';
export const OPEN_SOCIAL_FEED_IMAGE = 'OPEN_SOCIAL_FEED_IMAGE';
export const OPEN_SOCIAL_POST_ADD = 'OPEN_SOCIAL_POST_ADD';
export const FETCH_SOCIAL_FEED_LIKE = 'FETCH_SOCIAL_FEED_LIKE';

export const fetchSocialFeed = (
  session,
  pageCount = 0,
  dataArr = [],
  callback
) => {
  let perPage = 20;
  let offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  let offSetQuery = `limit=${perPage}&offset=${offset}`;
  let filter = encodeURI(`(eventid=${session.eventid})AND(isvisible=1)`);
  let related = `appuser_by_postedbyid,appuser_by_socialfeedlikes,appuser_by_socialfeedcomments,socialfeedlikes_by_socialfeedid,socialfeedcomments_by_socialfeedid,socialfeedpollresult_by_socialfeedidfk,appuser_by_socialfeedpollresult&appuser_by_postedbyid.fields=${FIELDS.appuser.relatedInfo}&appuser_by_socialfeedlikes.fields=${FIELDS.appuser.relatedInfo}&appuser_by_socialfeedcomments.fields=${FIELDS.appuser.relatedInfo}&appuser_by_socialfeedpollresult.fields=${FIELDS.appuser.relatedInfo}`;
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialFeed}?include_count=true&related=${related}&filter=(${filter})&eventid=${session.eventid}&order=pinorder,feeddate%20DESC&${offSetQuery}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_SOCIAL_FEED,
          payload: {}
        });
        dispatch({
          type: FETCH_SOCIAL_FEED,
          payload: {
            data: dataArr.concat(data.resource),
            count: data.meta.count
          }
        });
        callback({
          success: 1,
          data: data.resource,
          total_count: data.meta.count,
          next: data.meta.next
        });
      },
      error => {}
    );
  };
};

export const updateSocialFeedLocally = data => {
  return dispatch => {
    dispatch({
      type: FETCH_SOCIAL_FEED,
      payload: {
        data: data.resource,
        count: data.count
      }
    });
  };
};

export const getFeeds = (session, page, callback) => {
  let limit = page == 0 ? 20 : page;
  let offSetQuery = `&limit=${limit}&offset=0`;
  let filter = encodeURI(`(eventid=${session.eventid})AND(isvisible=1)`);
  let related = `appuser_by_postedbyid,appuser_by_socialfeedlikes,appuser_by_socialfeedcomments,socialfeedlikes_by_socialfeedid,socialfeedcomments_by_socialfeedid,socialfeedpollresult_by_socialfeedidfk,appuser_by_socialfeedpollresult&appuser_by_postedbyid.fields=${FIELDS.appuser.relatedInfo}&appuser_by_socialfeedlikes.fields=${FIELDS.appuser.relatedInfo}&appuser_by_socialfeedcomments.fields=${FIELDS.appuser.relatedInfo}&appuser_by_socialfeedpollresult.fields=${FIELDS.appuser.relatedInfo}`;
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialFeed}?include_count=true&related=${related}
  &filter=(${filter})&eventid=${session.eventid}&order=pinorder,feeddate%20DESC${offSetQuery}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_SOCIAL_FEED,
          payload: {}
        });
        dispatch({
          type: FETCH_SOCIAL_FEED,
          payload: {
            data: data.resource,
            count: data.meta.count
          }
        });
        callback({
          success: 1,
          data: data.resource,
          total_count: data.meta.count,
          next: data.meta.next,
          error: null
        });
      },
      error => {
        callback({
          success: 0,
          data: [],
          total_count: 0,
          next: 0,
          error
        });
      }
    );
  };
};

export const socialLikeAction = (session, data, callback) => {
  const isDelete = data.delete;
  const isPatch = data.patch;
  const restURL = isDelete || isPatch ? `/${data.socialfeedlikeid}` : '';
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialfeedlikes}${restURL}`;

  let body = { resource: _.omit(data, ['delete', 'patch']) };
  if (isPatch)
    body = _.omit(data, [
      'delete',
      'patch',
      'socialfeedlikeid',
      'likedbyid',
      'socialfeedid'
    ]);

  return dispatch => {
    isDelete
      ? deleteRequest(
          url,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {}
        )
      : isPatch
      ? patchRequest(
          url,
          body,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {}
        )
      : postRequest(
          url,
          body,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {}
        );
  };
};

export const deleteFeed = (session, socialfeedid, callback) => {
  let deleteUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialFeed}/${socialfeedid}`;
  return dispatch => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      delres => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearFeedComment = () => {
  return dispatch => {
    dispatch({ type: FETCH_SOCIAL_FEED_COMMENT, payload: {} });
  };
};

export const setFeedComment = (showModal = false, socialfeedid = '') => {
  return dispatch => {
    dispatch({
      type: SET_SOCIAL_FEED_COMMENT,
      payload: {
        showModal: showModal,
        socialfeedid: socialfeedid
      }
    });
  };
};

export const fetchComments = (session, socialfeedid, callback) => {
  let filter = encodeURI(
    `(socialfeedid=${socialfeedid})AND(eventid=${session.eventid})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialfeedcomments}?related=appuser_by_commentbyid&filter=(${filter})&order=createdon`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_SOCIAL_FEED_COMMENT, payload: data });
        callback({ success: 1, resource: data.resource });
      },
      error => {}
    );
  };
};

export const sendChat = (session, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialfeedcomments}`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const openSocialImage = (
  showModal = false,
  item = [],
  currentindex = ''
) => {
  return dispatch => {
    dispatch({
      type: OPEN_SOCIAL_FEED_IMAGE,
      payload: {
        showModal: showModal,
        photo: item,
        currentindex: currentindex
      }
    });
  };
};

export const addPostModal = (showModal = false, editItem = null) => {
  return dispatch => {
    dispatch({
      type: OPEN_SOCIAL_POST_ADD,
      payload: {
        showModal: showModal,
        inEditMode: !_.isNull(editItem),
        editItem
      }
    });
  };
};

export const addSocialFeed = (session, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialFeed}`;
  let body = {};
  let isUpdate = false;

  // --- Deleting restricted fields
  delete values.idbehalf;
  delete values.onbehalf;

  if (!_.isNil(values?.socialfeedid)) {
    url = `${url}/${values?.socialfeedid}`;
    body = _.cloneDeep(values);
    delete body.socialfeedid;
    isUpdate = true;
  } else {
    body = { resource: values };
  }

  if (_.isEmpty(body) || _.isEmpty(values)) return dispatch => {};

  return dispatch => {
    if (isUpdate)
      patchRequest(
        url,
        body,
        session,
        dispatch,
        response => {
          callback({ success: 1, error: null });
        },
        error => {
          callback({ success: 0, error });
        }
      );
    else
      postRequest(
        url,
        body,
        session,
        dispatch,
        response => {
          callback({ success: 1 });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
  };
};

export const addSocialFeedPoll = (session, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialfeedpollresult}?fields=*`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response.resource[0] });
      },
      error => {
        callback({ success: 0, response: error });
      }
    );
  };
};

export const deleteComment = (session, socialfeedcommentid, callback) => {
  let deleteUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialfeedcomments}/${socialfeedcommentid}`;

  return dispatch => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      delres => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchLikeList = (session, socialfeedid, callback) => {
  let filter = encodeURI(
    `(socialfeedid=${socialfeedid})AND(eventid=${session.eventid})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialfeedlikes}?related=appuser_by_likedbyid&filter=(${filter})&order=createdon`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_SOCIAL_FEED_LIKE, payload: data });
        callback({ success: 1, resource: data.resource });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const clearFeedLike = () => {
  return dispatch => {
    dispatch({ type: FETCH_SOCIAL_FEED_LIKE, payload: {} });
  };
};

export const exportSocialPollResult = (
  session,
  extra = { postId: null },
  callback
) => {
  if (_.isNull(extra?.postId)) return dispatch => {};

  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.postCommon.socialPollExport.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.postCommon.socialPollExport.payload);
  postBody.eventid = session.eventid;
  postBody.id = extra.postId;

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        if (!res?.success || res?.success == 0) {
          callback({ success: 0, data: null, error: null });
        } else {
          downloadFileFromURL(res?.path);
          callback({ success: 1, data: res, error: null });
        }
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};

export const updateSocialPost = (
  session,
  extra = { postId: null, values: {} },
  callback
) => {
  if (_.isNull(extra?.postId) || _.isEmpty(extra?.values))
    return dispatch => {};

  let patchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.socialFeed}/${extra.postId}`;
  let patchBody = { ...extra.values };

  // --- Deleting restricted fields
  delete patchBody.idbehalf;
  delete patchBody.onbehalf;

  return dispatch => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res, error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};
